<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
@if (isScreenSmall) {
  <fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="'over'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="false"
  >
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <div class="flex h-20 items-center px-8 pt-6">
        <img
          class="w-24"
          src="images/logo/logo-text-on-dark.svg"
          alt="Logo image"
        />
      </div>
    </ng-container>
  </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div
  class="dark:bg-card flex w-full min-w-0 flex-auto flex-col items-center bg-gray-200"
>
  <!-- Header -->
  <div
    class="z-49 flex-0 relative flex h-16 w-full flex-col justify-center overflow-hidden shadow sm:h-20 md:h-36 dark:shadow-none print:hidden"
  >
    <!-- Top bar -->
    <div
      class="dark relative flex w-full flex-auto justify-center bg-gray-800 px-4 md:px-8 dark:bg-gray-900"
    >
      <div class="max-w-360 flex h-16 w-full items-center sm:h-20">
        <!-- Logo -->
        @if (!isScreenSmall) {
          <div class="flex items-center">
            <img
              class="w-24"
              src="images/logo/logo-text-on-dark.svg"
              alt="Logo image"
            />
          </div>
        }
        <!-- Navigation toggle button -->
        @if (isScreenSmall) {
          <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
          </button>
        }
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
          <!-- <languages></languages> -->
          <!-- <fuse-fullscreen class="hidden md:block"></fuse-fullscreen> -->
          <!-- <search [appearance]="'bar'"></search> -->
          <!-- <shortcuts></shortcuts> -->
          <!-- <messages></messages> -->
          <!-- <notifications></notifications> -->
          <!-- <button
            class="lg:hidden"
            mat-icon-button
            (click)="quickChat.toggle()"
          > -->
          <mat-icon
            [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
          ></mat-icon>
          <!-- </button> -->
          <user></user>
        </div>
      </div>
    </div>
    <!-- Bottom bar -->
    @if (!isScreenSmall) {
      <div
        class="bg-card flex flex-auto justify-center px-4 md:px-8 dark:bg-gray-700"
      >
        <div class="max-w-360 relative flex h-16 w-full items-center">
          <fuse-horizontal-navigation
            class="-mx-4"
            [name]="'mainNavigation'"
            [navigation]="navigation.horizontal"
          ></fuse-horizontal-navigation>
        </div>
      </div>
    }
  </div>

  <!-- Content -->
  <div class="flex w-full flex-auto justify-center sm:p-6 md:p-8">
    <div
      class="bg-default sm:max-w-360 flex w-full flex-auto flex-col sm:overflow-hidden sm:rounded-lg sm:shadow-lg"
    >
      <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                 Otherwise, layout changes won't be registered and the view won't be updated! -->
      @if (true) {
        <router-outlet></router-outlet>
      }
    </div>
  </div>

  <!-- Footer -->
  <div
    class="bg-card z-49 flex-0 relative flex w-full justify-center border-t px-6 md:px-8 print:hidden"
  >
    <div class="max-w-360 flex h-14 w-full items-center sm:h-20">
      <a
        href="https://arsera.it/"
        target="_blank"
        rel="noopener noreferrer"
        class="text-secondary font-medium"
      >
        <span class="text-secondary font-medium"
          >Arsera &copy; {{ currentYear }}</span
        >
      </a>
    </div>
  </div>

  <!-- Quick chat -->
  <!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
</div>
